import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import classnames from 'classnames';
import { toast, ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import { sanitizeHtml } from '../../utils/useSanitize';
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Badge,
} from 'reactstrap';
import RequirementTab from './components/RequirementTab';
import SupportDocumentTab from './components/SupportDocumentTab';
import useRespondClauseDetail from '../../shared/offer-domain/respond/useRespondClauseDetail';
import {
  getVisibleProcurementClauses,
  getProcurementMitraFirstItem,
  getProcurementMitraId,
} from '../../shared/offer-domain/respond';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import { unwrapProcurement } from '../../shared/offer-domain/procurement';
import { isOfferInvitationValidationBlocked } from './utils/offerEditAccess';
import metaMask from '../../assets/images/nft/newrecord.png';

const getOfferingStatusBadgeColor = wording => {
  if (wording === 'Submission Deadline') return 'warning';
  if (wording === 'Opening') return 'primary';
  return 'danger';
};

const getSubmissionStatusBadgeColor = wording => {
  if (wording === 'Not Started') return 'danger';
  if (wording === 'Drafted') return 'primary';
  return 'secondary';
};

const parseProcurementDate = value => {
  if (value == null || value === '') return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toDate() : null;
};

const OfferForm = () => {
  const token = getAuthToken();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    statusOfferingWording,
    submissionStatusWording,
    idOffer: idOfferFromState,
  } = location.state || {};
  const [isLoadingMitra, setIsLoadingMitra] = useState(Boolean(id));
  const [isLoadingProcurement, setIsLoadingProcurement] = useState(false);
  const [isLoadingQty, setIsLoadingQty] = useState(false);
  const [activeTab, setactiveTab] = useState(1);
  const [visitedTabs, setVisitedTabs] = useState({ 1: true });
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [qtyDeliveryData, setQtyDeliveryData] = useState({ items: [] });
  const [formMain, setFormMain] = useState({});
  const [form, setForm] = useState({
    procurementNumber: '',
    statusProcurement: '',
    titleProcurement: '',
    description: '',
    procurementType: '',
    contractType: '',
    contractPeriodSpot: '',
    contractPeriodTermStart: '',
    contractPeriodTermEnd: '',
    productTypeId: '',
    productType: '',
    productName: '',
    productNameId: '',
    operationalTolerance: '',
    partyType: '',
    operationalToleranceCounter: null,
    operationalToleranceOptionsCounter: null,
    operationalToleranceOptionsCounterLabel: null,
    productSpecification: '',
    ratioLpgId: '',
    ratioLpg: '',
    refPropaneFrequency: null,
    refPropaneRangeQuantityFrom: null,
    refPropaneRangeQuantityTo: null,
    refButaneFrequency: null,
    refButaneRangeQuantityFrom: null,
    refButaneRangeQuantityTo: null,
    notesForQuantityAndDeliveryTerms: '',
    globalNotes: '',
    quantityDiscrepancy: '',
    delayPenaltyTerms: '',
    delivery: '',
    nominationProcedure: '',
    firstTimeSupply: '',
    redChannelPolicy: '',
    deliveryCustom: '',
    invoicingQuantityId: '',
    invoicingQuantity: '',
    modeInvoicingQuantityId: '',
    modeInvoicingQuantity: '',
    descriptionOfPaymentTerms: '',
    paymentCurrencyId: '',
    paymentCurrency: '',
    lawId: '',
    law: '',
    arbitrationId: '',
    arbitration: '',
    notesForLoadingPort: '',
    portRestriction: [],
    otherTermsAndCondition: '',
    additionalNotes: '',
    counterPaymentTerm: [],
    counterCompliance: [],
    procurementClauseDetails: [],
    proposalSubmissionDeadline: '',
    proposalValidityPeriodMax: '',
    proposalValidityPeriodMaxCounter: null,
    fileHasilOptimasiHilir: '',
    filePenetapanHargaDasarImpor: '',
    fileSpesifikasi: '',
    fileGeneralTermsAndConditions: '',
    fileDocumentQ88: '',
    fileDocumentGasFormC: '',
    fileSupporting1: '',
    fileSupporting2: '',
    fileSupporting3: '',
    fileSupporting4: '',
    fileSupporting5: '',
    subStatus: '',
    isInformationAboutDMUTConfirmed: '',
    isAcknowledgedDMUT: '',
    hpsRequestNumber: '',
    hpsRequestDate: '',
    userId: '',
    user: '',
    isProcurementRequirementCompleted: '',
    isSupportingDocumentsCompleted: '',
    isDMUTInvitationCompleted: '',
    isHPSRequestCompleted: '',
    id: '',
    createdBy: '',
    updatedBy: '',
    createdDate: '',
    updatedDate: '',
    isDeleted: '',
    deletedDate: '',
    deletedBy: '',
  });
  const visibleClauseDetailIds = useMemo(
    () =>
      getVisibleProcurementClauses({
        procurementClauseDetails: form.procurementClauseDetails,
      })
        .map(clause => clause.id)
        .filter(Boolean),
    [form.procurementClauseDetails]
  );
  const {
    clauseResponses,
    isLoading: isClauseResponsesLoading,
    isSaving: isClauseResponsesSaving,
    saveResponse: saveClauseResponse,
    deleteResponse: deleteClauseResponse,
    refresh: refreshClauseResponses,
  } = useRespondClauseDetail(
    token,
    formMain.id || id,
    visibleClauseDetailIds,
    formMain.ids
  );

  const fetchDataInvitation = async (id, token) => {
    setIsLoadingMitra(true);
    try {
      const response = await axios.get(
        `${api.API_URL}/dmut/get-procurement-mitra/${id}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const firstItem = getProcurementMitraFirstItem(response);
      if (!firstItem) return;

      const proposalDate = firstItem.procurement?.proposalValidityPeriodMax
        ? new Date(firstItem.procurement.proposalValidityPeriodMax)
        : null;
      setFormMain({
        ids: firstItem.procurementId || null,
        id: getProcurementMitraId(firstItem) || id || null,
        idOffer:
          firstItem.idOffer ?? firstItem.IdOffer ?? idOfferFromState ?? null,
        companyName: firstItem.companyMitra?.companyName || null,
        paymentTermResponse:
          sanitizeHtml(firstItem.paymentTermResponse) || null,
        paymentCurrencyResponse: firstItem.paymentCurrencyResponse || null,
        lawArbitrationResponse: firstItem.lawArbitrationResponse || null,
        loadingPortResponse: firstItem.loadingPortResponse || null,
        addLoadingPortResponse: firstItem.addLoadingPortResponse || null,
        additionalNotesResponse:
          sanitizeHtml(firstItem.additionalNotesResponse) || null,
        statusOffering: firstItem.statusOffering ?? null,
        submissionStatus: firstItem.submissionStatus ?? null,
        statusOfferingWording: statusOfferingWording ?? null,
        statusOfferingWordingFlag: isOfferInvitationValidationBlocked({
          proposalDate,
          submissionStatus: firstItem.submissionStatus,
          statusOfferingWording: statusOfferingWording ?? null,
        }),
      });
    } catch {
      void 0;
    } finally {
      setIsLoadingMitra(false);
    }
  };

  const fetchDataInvitationValidation = async (id, token) => {
    try {
      const response = await axios.get(
        `${api.API_URL}/dmut/get-procurement-mitra/${id}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const firstItem = getProcurementMitraFirstItem(response);
      if (!firstItem) return false;

      const proposalDate = firstItem.procurement?.proposalValidityPeriodMax
        ? new Date(firstItem.procurement.proposalValidityPeriodMax)
        : null;
      return isOfferInvitationValidationBlocked({
        proposalDate,
        submissionStatus: firstItem.submissionStatus,
        statusOfferingWording: statusOfferingWording ?? null,
      });
    } catch {
      void 0;
    }
  };

  useEffect(() => {
    fetchDataInvitation(id, token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, token]);

  useEffect(() => {
    if (formMain.ids) {
      fetchDataProcurement(formMain.ids, token);
    }
  }, [formMain.ids, token]);

  useEffect(() => {
    fetchQtyDeliveryList(formMain.ids, token);
  }, [formMain.ids, token]);

  useEffect(() => {
    setVisitedTabs(prev =>
      prev[activeTab] ? prev : { ...prev, [activeTab]: true }
    );
  }, [activeTab]);

  const fetchDataProcurement = async (ids, token) => {
    setIsLoadingProcurement(true);
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      const data = unwrapProcurement(response) ?? response;
      const normalizedProcurement = data;
      setForm({
        procurementNumber: data.procurementNumber || null,
        statusProcurement: data.statusProcurement || null,
        titleProcurement: data.titleProcurement || null,
        description: data.description || null,
        procurementType: data.procurementType || null,
        contractType: data.contractType || null,
        contractPeriodSpot: data.contractPeriodSpot || null,
        contractPeriodTermStart: data.contractPeriodTermStart || null,
        contractPeriodTermEnd: data.contractPeriodTermEnd || null,
        productTypeId: data.productTypeId || null,
        productType: data.productType || null,
        productTypename: data.productType.name || null,
        productName: data.productType?.product?.name || null,
        productNameId: data.productType?.product?.id || null,
        operationalTolerance: data.operationalTolerance || null,
        partyType: data.partyType || null,
        operationalToleranceCounter:
          data.operationalToleranceCounter ??
          data.OperationalToleranceCounter ??
          null,
        operationalToleranceOptionsCounter:
          data.operationalToleranceOptionsCounter ??
          data.OperationalToleranceOptionsCounter ??
          null,
        operationalToleranceOptionsCounterLabel:
          data.operationalToleranceOptionsCounterLabel ??
          data.OperationalToleranceOptionsCounterLabel ??
          null,
        productSpecification: data.productSpecification || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        refPropaneFrequency: data.refPropaneFrequency || null,
        refPropaneRangeQuantityFrom: data.refPropaneRangeQuantityFrom || null,
        refPropaneRangeQuantityTo: data.refPropaneRangeQuantityTo || null,
        refButaneFrequency: data.refButaneFrequency || null,
        refButaneRangeQuantityFrom: data.refButaneRangeQuantityFrom || null,
        refButaneRangeQuantityTo: data.refButaneRangeQuantityTo || null,
        notesForQuantityAndDeliveryTerms:
          data.notesForQuantityAndDeliveryTerms || null,
        globalNotes: data.globalNotes || null,
        quantityDiscrepancy: data.quantityDiscrepancy || null,
        delayPenaltyTerms: data.delayPenaltyTerms || null,
        delivery: data.delivery || null,
        nominationProcedure: data.nominationProcedure || null,
        firstTimeSupply: data.firstTimeSupply || null,
        redChannelPolicy: data.redChannelPolicy || null,
        deliveryCustom: data.deliveryCustom || null,
        invoicingQuantityId: data.invoicingQuantityId || null,
        invoicingQuantity: data.invoicingQuantity || null,
        modeInvoicingQuantityId: data.modeInvoicingQuantityId || null,
        modeInvoicingQuantity: data.modeInvoicingQuantity || null,
        descriptionOfPaymentTerms: data.descriptionOfPaymentTerms || null,
        paymentCurrencyId: data.paymentCurrencyId || null,
        paymentCurrency: data.paymentCurrency || null,
        lawId: data.lawId || null,
        law: data.law || null,
        arbitrationId: data.arbitrationId || null,
        arbitration: data.arbitration || null,
        notesForLoadingPort: data.notesForLoadingPort || null,
        portRestriction: data.portRestriction || [],
        otherTermsAndCondition: data.otherTermsAndCondition || null,
        additionalNotes: data.additionalNotes || null,
        counterPaymentTerm: data.counterPaymentTerm || [],
        counterCompliance: data.counterCompliance || [],
        proposalSubmissionDeadline: parseProcurementDate(
          data.proposalSubmissionDeadline
        ),
        proposalValidityPeriodMax: parseProcurementDate(
          data.proposalValidityPeriodMax
        ),
        proposalValidityPeriodMaxCounter: parseProcurementDate(
          data.proposalValidityPeriodMaxCounter ??
            data.ProposalValidityPeriodMaxCounter
        ),
        fileHasilOptimasiHilir: data.fileHasilOptimasiHilir || null,
        filePenetapanHargaDasarImpor: data.filePenetapanHargaDasarImpor || null,
        fileSpesifikasi: data.fileSpesifikasi || null,
        fileGeneralTermsAndConditions:
          data.fileGeneralTermsAndConditions || null,
        fileDocumentQ88: data.fileDocumentQ88 || null,
        fileDocumentGasFormC: data.fileDocumentGasFormC || null,
        fileSupporting1: data.fileSupporting1 || null,
        fileSupporting2: data.fileSupporting2 || null,
        fileSupporting3: data.fileSupporting3 || null,
        fileSupporting4: data.fileSupporting4 || null,
        fileSupporting5: data.fileSupporting5 || null,
        subStatus: data.subStatus || null,
        isInformationAboutDMUTConfirmed:
          data.isInformationAboutDMUTConfirmed || null,
        isAcknowledgedDMUT: data.isAcknowledgedDMUT || null,
        hpsRequestNumber: data.hpsRequestNumber || null,
        hpsRequestDate: data.hpsRequestDate || null,
        userId: data.userId || null,
        user: data.user || null,
        isProcurementRequirementCompleted:
          data.isProcurementRequirementCompleted || null,
        isSupportingDocumentsCompleted:
          data.isSupportingDocumentsCompleted || null,
        isDMUTInvitationCompleted: data.isDMUTInvitationCompleted || null,
        isHPSRequestCompleted: data.isHPSRequestCompleted || null,
        id: data.id || null,
        createdBy: data.createdBy || null,
        updatedBy: data.updatedBy || null,
        createdDate: data.createdDate || null,
        updatedDate: data.updatedDate || null,
        isDeleted: data.isDeleted || null,
        deletedDate: data.deletedDate || null,
        deletedBy: data.deletedBy || null,
        procurementClauseDetails:
          normalizedProcurement.procurementClauseDetails ?? [],
      });
    } catch {
      void 0;
    } finally {
      setIsLoadingProcurement(false);
    }
  };

  function toggleTab(tab) {
    if (activeTab !== tab && tab >= 1 && tab <= 2) {
      setactiveTab(tab);
    }
  }

  const fetchQtyDeliveryList = async (ids, token) => {
    if (!ids) {
      return;
    }
    setIsLoadingQty(true);
    setError(null);

    try {
      const response = await fetch(
        `${api.API_URL}/quantity-delivery?ProcurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(
          `HTTP error: ${response.status} ${response.statusText}`
        );
      }
      const result = await response.json();

      if (!result.data?.items) {
        return;
      }
      const items = result.data.items.map(item => ({
        procurementId: item.procurementId,
        ratioLpgId: item.ratioLpgId,
        ratioName: item.ratioLpg?.ratioName ?? null,
        deliveryUnit: item.deliveryUnit,
        frequency: item.frequency,
        pricingPeriod:
          item.pricingPeriod === '1' ? 'Fixed Date' : 'Floating Date',
        indexPricename: item.indexPrice?.name ?? null,
        otherIndexPricename: item.otherIndexPrice?.name ?? null,
        startDatePublishIndex: item.startDatePublishIndex,
        endDatePublishIndex: item.endDatePublishIndex,
        schemaBL: item.schemaBL,
        notesForPricing: item.notesForPricing,
        isCorrelationBetweenTwoIndex: item.isCorrelationBetweenTwoIndex,
        id: item.id,
      }));
      setQtyDeliveryData({ items });
    } catch (error) {
      setIsLoadingQty(false);
      setError(error.message);
    } finally {
      setIsLoadingQty(false);
    }
  };

  const [modal_handleInvitationAccept, setmodal_handleInvitationAccept] =
    useState(false);
  function handleInvitationAccept() {
    setmodal_handleInvitationAccept(!modal_handleInvitationAccept);
  }

  const selectedFieldsOffer = {
    id: formMain.id,
    paymentTermResponse: formMain.paymentTermResponse,
    additionalNotesResponse: formMain.additionalNotesResponse,
  };

  const handleSaveAsDraft = async () => {
    try {
      //setIsLoading(true);
      await axios.post(
        `${api.API_URL}/dmut/respond-offer?id=${id}&status=1`,
        selectedFieldsOffer,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data has been Updated`);
    } catch {
      void 0;
    } finally {
      //setIsLoading(false);
    }
  };

  const handleSaveAsOffer = async () => {
    try {
      await axios.post(
        `${api.API_URL}/dmut/respond-offer?id=${id}&status=2`,
        selectedFieldsOffer,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data has been Saved`);
      navigate(`/apps-offer/view`);
    } catch {
      void 0;
    }
  };

  const statusOfferingLabel = statusOfferingWording;
  const submissionStatusLabel = submissionStatusWording;
  const offerNumber = formMain.idOffer || idOfferFromState;

  document.title = 'Offer Detail';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <div className='border-bottom border-bottom-dashed'>
                  <Row className='mt-n2 mb-1 mb-sm-0'>
                    <div className='col-sm order-3 order-sm-2'>
                      <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                        <h5 className='card-title mb-0 flex-grow-1'>
                          <Breadcrumb listClassName='p-3 py-2 bg-light'>
                            <BreadcrumbItem>
                              <Link to='/dashboard'>Home</Link>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                              <Link to='/apps-offer/view'>Offer</Link>
                            </BreadcrumbItem>
                            <BreadcrumbItem active>
                              Detail #{offerNumber || '-'}
                            </BreadcrumbItem>
                          </Breadcrumb>
                        </h5>
                      </div>
                    </div>
                  </Row>
                  <Row className='mb-4'>
                    <Col xs={12}>
                      <Row className='align-items-center g-3'>
                        <Col xs={12} lg>
                          <div className='d-flex align-items-start gap-3'>
                            <Button
                              color='light'
                              className='border shadow-sm rounded-circle d-flex align-items-center justify-content-center p-0 flex-shrink-0'
                              style={{ width: '2.5rem', height: '2.5rem' }}
                              onClick={() => navigate('/apps-offer/view')}
                            >
                              <i className='bx bx-arrow-back fs-5 text-dark'></i>
                            </Button>
                            <div>
                              <h4 className='mb-2 fw-bold text-dark'>
                                {form.titleProcurement}
                              </h4>
                              <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                <i className='bx bx-hash'></i>
                                <span>
                                  Procurement ID:{' '}
                                  {form.procurementNumber || '-'}
                                </span>

                                <i className='bx bx-calendar'></i>
                                <span>
                                  {form.updatedDate || form.createdDate
                                    ? dayjs(
                                        form.updatedDate || form.createdDate
                                      ).format('DD MMM YYYY')
                                    : 'N/A'}
                                </span>

                                {statusOfferingLabel && (
                                  <Badge
                                    color={getOfferingStatusBadgeColor(
                                      statusOfferingLabel
                                    )}
                                    className='px-2 py-1 fs-12 fw-medium rounded-pill'
                                  >
                                    Offering: {statusOfferingLabel}
                                  </Badge>
                                )}

                                {submissionStatusLabel && (
                                  <Badge
                                    color={getSubmissionStatusBadgeColor(
                                      submissionStatusLabel
                                    )}
                                    className='px-2 py-1 fs-12 fw-medium rounded-pill'
                                  >
                                    Submission: {submissionStatusLabel}
                                  </Badge>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className='mt-3 mb-0 border-secondary opacity-10' />
                    </Col>
                    <Col xs={12}>
                      <Card>
                        <CardBody className='checkout-tab'>
                          <Nav
                            tabs
                            className='nav-tabs-custom nav-primary mt-1 mb-3'
                          >
                            <NavItem>
                              <NavLink
                                className={classnames('cursor-pointer', {
                                  active: activeTab === 1,
                                })}
                                onClick={() => toggleTab(1)}
                              >
                                <i className='ri-store-2-fill me-1 align-bottom'></i>
                                <span className='fw-semibold'>
                                  Input Offering
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames('cursor-pointer', {
                                  active: activeTab === 2,
                                })}
                                onClick={() => toggleTab(2)}
                              >
                                <i className='ri-file-text-line me-1 align-bottom'></i>
                                <span className='fw-semibold'>
                                  Document Attachment
                                </span>
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent activeTab={activeTab}>
                            {visitedTabs[1] && (
                              <TabPane tabId={1} id='pills-bill-info'>
                                <RequirementTab
                                  goNext={() => setactiveTab(2)}
                                  ids={formMain.ids}
                                  form={form}
                                  setForm={setForm}
                                  formMain={formMain}
                                  setFormMain={setFormMain}
                                  errors={errors}
                                  error={error}
                                  setErrors={setErrors}
                                  isLoading={
                                    isLoadingMitra ||
                                    isLoadingProcurement ||
                                    isLoadingQty ||
                                    !formMain.ids
                                  }
                                  qtyDeliveryData={qtyDeliveryData}
                                  token={token}
                                  handleInvitationAccept={
                                    handleInvitationAccept
                                  }
                                  handleSaveAsDraft={handleSaveAsDraft}
                                  fetchDataInvitationValidation={() =>
                                    fetchDataInvitationValidation(
                                      formMain.id,
                                      token
                                    )
                                  }
                                  clauseResponses={clauseResponses}
                                  isClauseResponsesLoading={
                                    isClauseResponsesLoading
                                  }
                                  isClauseResponsesSaving={
                                    isClauseResponsesSaving
                                  }
                                  saveClauseResponse={saveClauseResponse}
                                  deleteClauseResponse={deleteClauseResponse}
                                  refreshClauseResponses={
                                    refreshClauseResponses
                                  }
                                  refreshProcurement={() =>
                                    fetchDataProcurement(formMain.ids, token)
                                  }
                                />
                              </TabPane>
                            )}
                            {visitedTabs[2] && (
                              <TabPane tabId={2}>
                                <SupportDocumentTab
                                  ids={formMain.ids}
                                  token={token}
                                  formMain={formMain}
                                  handleInvitationAccept={
                                    handleInvitationAccept
                                  }
                                  handleSaveAsDraft={handleSaveAsDraft}
                                  fetchDataInvitationValidation={() =>
                                    fetchDataInvitationValidation(
                                      formMain.id,
                                      token
                                    )
                                  }
                                />
                              </TabPane>
                            )}
                          </TabContent>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer closeButton={false} limit={1} />
        </Container>
      </div>

      <Modal
        isOpen={modal_handleInvitationAccept}
        toggle={handleInvitationAccept}
        id='submit-offer-modal'
        centered
      >
        <ModalHeader toggle={() => setmodal_handleInvitationAccept(false)} />
        <ModalBody className='text-center p-5'>
          <div className='mt-1 pt-2'>
            <Row className='justify-content-center mb-1'>
              <Col lg={12} className='text-center'>
                <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
                <h5>Confirm Offering Submission</h5>
                <p className='text-muted pb-1'>
                  Are you sure you want to submit this offering? Once submitted,
                  the data cannot be modified or undone. Please ensure that all
                  input is final before proceeding.
                </p>
              </Col>
            </Row>
            <Button
              color='danger'
              className='btn-label right ms-2'
              onClick={() => setmodal_handleInvitationAccept(false)}
            >
              <i className='ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
              Cancel
            </Button>
            <Button
              color='primary'
              className='btn-label right ms-2'
              onClick={() => {
                handleSaveAsOffer();
                setmodal_handleInvitationAccept(false);
              }}
            >
              <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
              Confirmation
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default OfferForm;
